import React, { useState } from "react";
import { Alert, Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { developerDocumentState } from "@/const";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { DocumentStateBadge } from "@components/Game/Misc";
import { Awesome, DevModal } from "@components/Helpers";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function StatisticsDocuments({ developerId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:developer:statistics:documents", { developer_id: developerId }));
    const [showModal, setShowModal] = useState(false);

    if (!apiData) return;

    const getFile = (month, year) => {
        window.open(
            url_reverse("devs:edit", { dev_id: developerId }) +
                "developer_document_file/" +
                `?month=${month}&year=${year}`
        );
    };
    const commentsHeader = <span>{t("Комментарии")}</span>;

    return (
        <>
            <ListingCard header={header} hideModalFilter={true}>
                {apiData.declined > 0 && (
                    <Alert variant="danger">
                        {t("Модератор нашел ошибку в документах. Исправьте ошибку и отправьте документы повторно.")}
                    </Alert>
                )}
                <Table hover responsive className="dmg-table">
                    <thead>
                        <tr>
                            <th>{t("Документ")}</th>
                            <th>{t("Статус")}</th>
                            <th>{t("Скачать")}</th>
                            <th>{t("Загрузить файлы")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiData.object_list?.map((o, i) => {
                            return (
                                <tr key={`object_list${i}`}>
                                    <td>
                                        {t("УПД")} {o.month}.{o.year}
                                    </td>
                                    <td>
                                        <DocumentStateBadge state={o.state} text={developerDocumentState[o.state]} />
                                    </td>
                                    <td>
                                        <DevForm.Button
                                            variant="primary"
                                            size="lg"
                                            name="download"
                                            onClick={() => {
                                                getFile(o.month, o.year);
                                            }}
                                        >
                                            <Awesome type="download" color="white" />
                                        </DevForm.Button>
                                    </td>
                                    <td>
                                        {["sent", "declined"].includes(o.state) && (
                                            <DevForm.Button
                                                variant="success"
                                                size="lg"
                                                name="upload"
                                                onClick={() => {
                                                    setShowModal({
                                                        month: o.month,
                                                        year: o.year,
                                                    });
                                                }}
                                            >
                                                <Awesome type="upload" color="white" />
                                            </DevForm.Button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
                <DeveloperDocumentFileUploadModal
                    developerId={developerId}
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            </ListingCard>
            {apiData.comments && (
                <>
                    <br />
                    <ListingCard header={commentsHeader} hideModalFilter={true}>
                        <Table hover responsive className="dmg-table">
                            <thead>
                                <tr>
                                    <th>{t("Документ")}</th>
                                    <th>{t("Комментарий")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {apiData.comments?.map((o, i) => {
                                    return (
                                        <tr key={`object_list${i}`}>
                                            <td>
                                                {t("УПД")} {o.month}.{o.year}
                                            </td>
                                            <td className="show-wrap-text">{o.comment}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </ListingCard>
                </>
            )}
        </>
    );
}

export function DeveloperDocumentFileUploadModal({ developerId, showModal, setShowModal }) {
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    const apiUploadUrl = url_reverse("api:developer:statistics:documents:upload", { developer_id: developerId });
    const { api_post_formdata } = useRequest();
    if (!showModal) {
        return;
    }
    const { month, year } = showModal;

    const onSubmit = (ev) => {
        ev.preventDefault();
        if (confirm(t("Подтвердите своё действие"))) {
            const formData = new FormData();
            [...files].forEach((file) => {
                formData.append("main-docfiles", file);
            });
            formData.append("main-developer_id", developerId);
            formData.append("main-month", month);
            formData.append("main-year", year);
            formData.append("main-signed", 1);
            api_post_formdata(ev, apiUploadUrl, formData, {
                then: (resp) => {
                    if (resp.status === "ok") {
                        setShowModal({});
                        location.reload();
                    }
                    if (resp.status === "fail") {
                        alert(JSON.stringify(resp.errors, null, 2));
                    }
                },
            });
        }
    };
    return (
        <DevModal
            show={showModal}
            onHide={setShowModal}
            header={t("Документы")}
            body={
                <>
                    <Form.Control
                        type="file"
                        multiple
                        name="docfiles"
                        onChange={(e) => setFiles(e.target.files)}
                        accept=".pdf,.png,.jpg,.jpeg,.tif,.tiff"
                    />
                    <DevForm.Button variant="primary" type="submit" name="submit">
                        {t("Подтвердить и отправить")}
                    </DevForm.Button>
                </>
            }
            renderWrapper={(children) => <Form onSubmit={onSubmit}>{children}</Form>}
        />
    );
}
